import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useEffect, useState } from "react";
import ReactOwlCarousel from "react-owl-carousel";
import styles from "./HeroBanner.module.css";

import { useNavigate } from "react-router";
import { enviroment } from "../../enviroment";
import ApiService from "../../services/ApiService";
import { useAppStore } from "../../store";
import { AppNotification } from "../../utils/helper";
import { HeroBannerLoader } from "../Loader/Loader";
import 'owl.carousel/dist/assets/owl.carousel.css';

export const HeroBanner = ({ allBanner }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const heroBanners = useAppStore((state) => state.heroBanners);
  const setHeroBanners = useAppStore((state) => state.setHeroBanners);
  const setPromoBanners = useAppStore((state) => state.setPromoBanners);
  const setOfferBanners = useAppStore((state) => state.setOfferBanners);

  const openBannerProd = (
    verticalId,
    subCatId,
    prodId,
    categoryId,
    siteLink
  ) => {
    const category = "Banner";
    if (siteLink !== null) {
      if (window !== undefined) window.open(siteLink, "_blank");
    } else if (prodId !== null) {
      const payload = {
        product_slug: prodId,
        company_id: Number.parseInt(enviroment.COMPANY_ID),
        store_id: Number.parseInt(enviroment.STORE_ID),
      };
      ApiService.productDetails(payload)
        .then((res) => {
          if (res.message === "Product Detail") {
            navigate(`/product?id=${prodId}`, {
              state: { product: res.payload },
            });
          } else {
            AppNotification(
              "Error",
              "Sorry, Product detail not found.",
              "danger"
            );
          }
        })
        .catch((err) => {
          AppNotification(
            "Error",
            "Sorry, Product detail not found.",
            "danger"
          );
        });
    } else if (subCatId !== null) {
      const payload = {
        store_id: Number.parseInt(enviroment.STORE_ID),
        category_id: subCatId,
      };
      navigate(`/store-product/${category}`, { state: { payload: payload } });
    } else if (categoryId !== null) {
      const payload = {
        store_id: Number.parseInt(enviroment.STORE_ID),
        category_id: categoryId,
      };
      navigate(`/store-product/${category}`, { state: { payload: payload } });
    } else if (verticalId !== null) {
      navigate(`/store/${category}`, { state: { cat: verticalId } });
    }
  };

  // load banners for first time
  useEffect(() => {
    const payload = {
      store_id: Number.parseInt(enviroment.STORE_ID),
    };

    ApiService.banner(payload)
      .then((res) => {
        if (res.message === "Fetch successfully.") {
          // hero banner
          setHeroBanners(res?.payload_banner?.banner);
          // promo banner
          setPromoBanners(res?.payload_banner?.promobanner);
          // offers
          setOfferBanners(res?.payload_banner?.sectionbanner);

          setLoading(false);
        }
      })
      .catch((err) => { });
  }, [setHeroBanners, setPromoBanners, setOfferBanners]);

  return (
    <React.Fragment>
      {/* Mobile Structure */}
      <div
        className={`${styles.heroBannerContainer} showInPhone heroBannerMobile col-12 d-inline-flex `}
      >
        {loading ? (
          <HeroBannerLoader />
        ) : (
          <ReactOwlCarousel
            className={`${styles.bannerContainer} col-12 d-inline-block owl-theme`}
            margin={0}
            loop={true}
            dots={true}
            items={1}
            nav={false}
            autoplay={true}
            autoplayTimeout={3000}
            autoplayHoverPause={true}
          >
            {heroBanners?.length > 0 &&
              heroBanners.map((item) => {
                return (
                  <React.Fragment key={item.id || item.banner_id}>
                    {item?.mobile_image !== "" && (
                      <button
                        type="button"
                        className={`${styles.item} border-0 bg-transparent p-0`}
                        onClick={() =>
                          openBannerProd(
                            item?.vertical_id,
                            item?.subcategory_id,
                            item?.product_id,
                            item?.category_id,
                            item?.site_link
                          )
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            openBannerProd(
                              item?.vertical_id,
                              item?.subcategory_id,
                              item?.product_id,
                              item?.category_id,
                              item?.site_link
                            );
                          }
                        }}
                      >
                        <img
                          src={item?.mobile_image}
                          alt={item?.name}
                          className="w-100"
                        />
                      </button>
                    )}
                  </React.Fragment>
                );
              })}
          </ReactOwlCarousel>
        )}
      </div>

      {/* Desktop Structure */}
      <div className={`${styles.heroBannerContainer} hideInPhone`}>
        {loading ? (
          <HeroBannerLoader />
        ) : (
          <div className={"col-12 d-inline-flex"}>
            <ReactOwlCarousel
              className={"owl-theme"}
              style={{
                position: 'relative',
                maxWidth: '100%',
                width: '100%',
              }}
              dots={true}
              items={1}
              loop={true}
              autoplay={true}
              autoplayTimeout={3000}
              autoplayHoverPause={true}
              nav={false}
            >
              {heroBanners.map((item, index) => {
                return (
                  <React.Fragment key={index}>
                    {item?.image !== "" && (
                      <div
                        className={styles.item}
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          openBannerProd(
                            item?.vertical_id,
                            item?.subcategory_id,
                            item?.product_id,
                            item?.category_id,
                            item?.site_link
                          )
                        }
                      >
                        <img
                          src={item?.image}
                          alt={item?.name}
                          className="object-fit-cover col-12 d-inline-block"
                        />
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </ReactOwlCarousel>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};